import get from 'transmute/get';
export const getHydratedEmailAddresses = get('hydratedEmailAddresses');